module.exports = __webpack_public_path__ + "static/media/london_hornsoffa_djup_tyg_alis_320_beige_miljo_2023_modell.37b263f0.jpg";